import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLoginPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'SportsTMS | Admin';
    
    // Add specific styles for this page
    const style = document.createElement('style');
    style.textContent = `
      body {
        background: #eee !important;
      }
      
      .wrapper {
        margin-top: 80px;
        margin-bottom: 80px;
      }
      
      .form-signin {
        max-width: 380px;
        padding: 15px 35px 45px;
        margin: 0 auto;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.1);
      }
      
      .form-signin .form-signin-heading,
      .form-signin .checkbox {
        margin-bottom: 30px;
      }
      
      .form-signin .checkbox {
        font-weight: normal;
      }
      
      .form-signin .form-control {
        position: relative;
        font-size: 16px;
        height: auto;
        padding: 10px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
      
      .form-signin .form-control:focus {
        z-index: 2;
      }
      
      .form-signin input[type="text"] {
        margin-bottom: -1px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      
      .form-signin input[type="password"] {
        margin-bottom: 20px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    `;
    document.head.appendChild(style);

    // Add Bootstrap CSS if not already present
    if (!document.querySelector('link[href*="bootstrap.min.css"]')) {
      const bootstrapLink = document.createElement('link');
      bootstrapLink.rel = 'stylesheet';
      bootstrapLink.href = 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css';
      document.head.appendChild(bootstrapLink);
    }

    // Cleanup function to remove styles and reset body background
    return () => {
      document.head.removeChild(style);
      document.body.style.background = '';
    };
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // For now, just show alert - in real app this would call API
    console.log('Admin login attempt:', formData);
    alert('Admin login functionality will be implemented with backend API');
    
    // In a real app, after successful login, you would redirect to admin dashboard
    // navigate('/admin/dashboard');
  };

  return (
    <div className="wrapper">
      <form className="form-signin" onSubmit={handleSubmit}>       
        <h2 className="form-signin-heading text-center">SportsTMS-ADMIN</h2>
        <div>
          <input 
            type="text" 
            className="form-control" 
            name="username" 
            placeholder="username" 
            required 
            autoFocus
            value={formData.username}
            onChange={handleChange}
          />
        </div>
        <div>
          <input 
            type="password" 
            className="form-control" 
            name="password" 
            placeholder="password" 
            required
            value={formData.password}
            onChange={handleChange}
          />
        </div>      
        <button 
          className="btn btn-lg btn-primary btn-block" 
          type="submit"
        >
          Login
        </button>   
      </form>
    </div>
  );
};

export default AdminLoginPage;